import React from 'react';

const WidgetEditor = ({ 
  tempPrompt, 
  setTempPrompt, 
  tempChartPrompt, 
  setTempChartPrompt 
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Primary Prompt
        </label>
        <textarea
          className="w-full p-3 border border-gray-300 rounded-md resize-y h-[20vh] focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          value={tempPrompt}
          onChange={e => setTempPrompt(e.target.value)}
          placeholder="Enter the main prompt for this widget..."
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Visualization Prompt (Optional)
          <span className="text-xs text-gray-500 ml-2">
            Leave empty for text-only widget
          </span>
        </label>
        <input
          className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          type="text"
          value={tempChartPrompt || ''}
          onChange={e => setTempChartPrompt(e.target.value)}
          placeholder="e.g., 'Give me a pie chart', 'show as bar chart', 'table format'"
        />
        <p className="text-xs text-gray-500 mt-1">
          Examples: "pie chart", "bar chart", "line chart", "table"
        </p>
      </div>
    </div>
  );
};

export default WidgetEditor;